// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"105ec6e1","320":"18497d9f","734":"73e0acee"}[chunkId] + ".chunk.css";
};